<template>
  <div id="subscribe" @mouseenter="showForm">
    <svg id="mailbox" width="112px" height="103px" viewBox="0 0 112 103" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="4.a-High-Resolution-Prototype---Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="v1.1_1.1.A-Landing_default" transform="translate(-1298.000000, -662.000000)" fill-rule="nonzero">
                <g id="Subscribe" transform="translate(1237.000000, 662.000000)">
                    <g id="mailbox" transform="translate(61.000000, 0.000000)">
                        <path d="M70.7931034,19.4206897 C69.8180353,19.4206897 69.0275862,18.6302406 69.0275862,17.6551724 L69.0275862,10.5931034 C69.0275862,9.6180352 69.8180353,8.82758621 70.7931034,8.82758621 C71.7681716,8.82758621 72.5586207,9.6180352 72.5586207,10.5931034 L72.5586207,17.6551724 C72.5586207,18.6302406 71.7681716,19.4206897 70.7931034,19.4206897 Z" id="Shape" fill="#95A5A5"></path>
                        <path d="M23.2035862,35.3103448 C24.1164973,25.3099043 32.5028051,17.6546714 42.5448276,17.6551724 C53.2705782,17.6551724 61.9655172,26.3501114 61.9655172,37.0758621 L61.9655172,65.3241379 C61.9655172,66.2992061 61.1750682,67.0896552 60.2,67.0896552 L51.3724138,67.0896552 L26.2035862,67.0896552 C24.546732,67.0896552 23.2035862,65.7465094 23.2035862,64.0896552 L23.2035862,35.3103448 L23.2035862,35.3103448 Z" id="Shape" fill="#752328"></path>
                        <path d="M51.761931,37.0758621 L51.761931,65.6785368 C51.761931,66.2552988 51.485366,66.7674656 51.0576181,67.0896552 L26.2035862,67.0896552 C24.546732,67.0896552 23.2035862,65.7465094 23.2035862,64.0896552 L23.2035862,35.3103448 C23.9563687,27.0640262 29.7907455,20.4123497 37.4447995,18.3328754 C45.694869,20.5739055 51.761931,28.1163647 51.761931,37.0758621 Z" id="Path" fill="#802F34"></path>
                        <g id="Group-3" transform="translate(0.000000, 35.310345)">
                            <path d="M45.3208276,1.58896552 C44.667723,0.597238643 43.5598765,3.73034936e-14 42.3724138,3.73034936e-14 L3.53103448,3.73034936e-14 C1.58089799,3.73034936e-14 2.09610107e-13,1.58089799 2.09610107e-13,3.53103448 L2.09610107e-13,28.2482759 C0.00693279779,29.2261521 0.415498205,30.1581919 1.12993103,30.825931 C1.77485932,31.4454429 2.63679882,31.7876837 3.53103448,31.7794604 L42.3724138,31.7794604 C43.2666495,31.7876837 44.128589,31.4454429 44.7735172,30.825931 C45.48795,30.1581919 45.8965154,29.2261521 45.9034483,28.2482759 L45.9034483,3.53103448 C45.9034483,2.84064115 45.7007164,2.16544397 45.3208276,1.58896552 Z" id="Shape" fill="#F3D55B"></path>
                            <path d="M18.1318621,16.4369655 L1.12993103,30.825931 C0.415498205,30.1581919 0.00693279779,29.2261521 -8.70414851e-14,28.2482759 L-8.70414851e-14,3.53103448 C-8.70414851e-14,2.84064115 0.202731802,2.16544397 0.58262069,1.58896552 L18.1318621,16.4369655 Z" id="Shape" fill="#F0C419"></path>
                            <path d="M44.7735172,30.825931 C44.128589,31.4454429 43.2666495,31.7876837 42.3724138,31.7794604 L3.53103448,31.7794604 C2.63679882,31.7876837 1.77485932,31.4454429 1.12993103,30.825931 L18.1318621,16.4369655 L20.6742069,18.5908966 C21.9895953,19.7011359 23.913853,19.7011359 25.2292414,18.5908966 L27.7715862,16.4369655 L44.7735172,30.825931 Z" id="Shape" fill="#F29C1F"></path>
                            <path d="M45.9034483,3.53103448 L45.9034483,28.2482759 C45.8965154,29.2261521 45.48795,30.1581919 44.7735172,30.825931 L27.7715862,16.4369655 L45.3208276,1.58896552 C45.7007164,2.16544397 45.9034483,2.84064115 45.9034483,3.53103448 L45.9034483,3.53103448 Z" id="Shape" fill="#F0C419"></path>
                            <path d="M28.2482759,8.82758621 L17.6551724,8.82758621 C16.6801042,8.82758621 15.8896552,8.03713713 15.8896552,7.06206897 C15.8896552,6.08700081 16.6801042,5.29655172 17.6551724,5.29655172 L28.2482759,5.29655172 C29.223344,5.29655172 30.0137931,6.08700081 30.0137931,7.06206897 C30.0137931,8.03713713 29.223344,8.82758621 28.2482759,8.82758621 Z" id="Shape" fill="#ECF0F1"></path>
                        </g>
                        <path d="M70.7931034,0 L84.9172414,0 C85.8923095,0 86.6827586,0.790448993 86.6827586,1.76551724 L86.6827586,8.82758621 C86.6827586,9.80265446 85.8923095,10.5931034 84.9172414,10.5931034 L69.0275862,10.5931034 L69.0275862,1.76551724 C69.0275862,0.790448993 69.8180353,0 70.7931034,0 Z" id="Shape" fill="#EFB217"></path>
                        <path d="M70.5275862,0 L82.5275862,0 C83.3560133,0 84.0275862,0.596953667 84.0275862,1.33333333 L84.0275862,6.66666667 C84.0275862,7.40304633 83.3560133,8 82.5275862,8 L69.0275862,8 L69.0275862,1.33333333 C69.0275862,0.596953667 69.6991592,0 70.5275862,0 Z" id="Shape-Copy-3" fill="#F0C419"></path>
                        <path d="M75.4102445,102.4 L64.52079,102.4 C63.7238782,102.477163 63.0304977,101.650694 62.9655172,100.546207 L62.9655172,65.3241379 L76.9655172,65.3241379 L76.9655172,100.546207 C76.9005368,101.650694 76.2071563,102.477163 75.4102445,102.4 Z" id="Shape" fill="#A56A43"></path>
                        <polygon id="Shape-Copy-2" fill="#9E5D32" points="62.9655172 65.3241379 76.9655172 65.3241379 76.9655172 81.6691701"></polygon>
                        <path d="M91.9793103,17.6551724 C102.590957,17.6551724 111.214771,26.1660968 111.397056,36.7342484 L111.4,37.0758621 L111.4,65.3241379 C111.4,66.2504527 110.68662,67.0101487 109.779283,67.0838025 L109.634483,67.0896552 L60.2,67.0896552 L60.3447999,67.0838025 C61.2017293,67.0142406 61.8856541,66.3327459 61.9590009,65.4768919 L61.9655172,65.3241379 L61.9655172,37.0758621 C61.9655172,26.4642152 53.4545929,17.840401 42.8864413,17.6581165 L42.5448276,17.6551724 L91.9793103,17.6551724 Z" id="Path" fill="#DB4434"></path>
                        <path d="M84.9038019,17.6551724 C93.9922689,17.6551724 101.379047,26.157964 101.542076,36.7190983 L101.544828,37.0758621 L101.544828,57.3241379 C101.544828,58.2478867 100.936935,59.0059386 100.162539,59.0831747 L100.032007,59.0896552 L61.9648276,59.0891724 L61.9655172,37.0758621 C61.9655172,26.4642152 53.4545929,17.840401 42.8864413,17.6581165 L42.5448276,17.6551724 L84.9038019,17.6551724 Z" id="Path" fill="#E64C3C"></path>
                        <rect id="Rectangle-path" fill="#F7F6F3" x="86.6827586" y="49.4344828" width="17.6551724" height="10.5931034" rx="1.76551724"></rect>
                        <rect id="Rectangle-path-Copy" fill="#FFFFFF" x="86.6827586" y="49.4344828" width="15" height="8" rx="1.76551724"></rect>
                    </g>
                </g>
            </g>
        </g>
    </svg>
    <div class="btnPrimary" id="subscribeBtn">Subscribe</div>
      <div id="form" class="form">
        <h2>Stay Tuned</h2>
        <p>Join our very unspammy email list and get notified when we launch new features.</p>
        <form @submit.prevent="showConfirmation">
          <input type="email" v-model="email" required placeholder="Your email" ><button type="submit" value=""><i class="fa fa-arrow-right"></i></button>
        </form>
      </div>
      <div id="confirmation" class="form">
        <h1 style="position:absolute;top:-24px;text-align: center; width:100%;">&#127881;</h1>
        <h2>You're in!</h2>
        <p>You have successfully subscribed to our newsletter. Thank you for your interest!</p>
        <!--<h5 @click="hideConfirmation" style="color:#B19967;text-align: center; cursor: pointer;">GOT IT.</h5>-->
      </div>
  </div>
</template>

<script>
    import {createSubscribedUser} from "../../api/api";

    export default {
      name: "Subscribe",
      data(){
        return{
          email:""
        }
      },
      methods:{
        showForm:function(){
            document.getElementById("mailbox").style.bottom="240px";
            document.getElementById("form").style.display="block";
            document.getElementById("subscribeBtn").style.display="none";
        },
        clickOutsidetoHide:function(){
          document.body.addEventListener('click', function(event){
            if (!(document.getElementById("subscribe") === event.target || (document.getElementById("subscribe").contains(event.target)))){
              document.getElementById("mailbox").style.bottom="35px";
              document.getElementById("form").style.display="none";
              document.getElementById("confirmation").style.display="none";
              document.getElementById("subscribeBtn").style.display="block"
            }
          })
        },
        showConfirmation:function(){
          createSubscribedUser({
            user_email: this.email
          })
          document.getElementById("form").style.display="none";
          document.getElementById("mailbox").style.bottom="192px";
          document.getElementById("confirmation").style.display="block";
        },
        // hideConfirmation:function(){
        //   document.getElementById("confirmation").style.display="none";
        //   document.getElementById("mailbox").style.bottom="35px";
        //   document.getElementById("form").style.display="none";
        //   document.getElementById("subscribeBtn").style.display="block"
        // }
      },
      mounted(){
        this.clickOutsidetoHide()
      }
    }
</script>

<style scoped>
  #subscribe{
    position:fixed;
    bottom:0;
    right:10%;
    z-index: 2000;
  }
  .btnPrimary{
    position: absolute;
    color:#fff;
    border:none;
    background-color: #FA6400;
    bottom:0;
    right:0;
    border-radius:8px 8px 0 0 ;
    transition: background-color 0.25s ease-in;
    -webkit-transition: background-color 0.25s ease-in;
  }
  .form{
    display: none;
    position: absolute;
    bottom:0;
    right:0;
    width:380px;
    background-color: #32344f;
    padding:30px 20px 40px 20px;
    border-radius: 8px 8px 0 0 ;
    box-shadow: 0 2px 12px -4px rgb(50,52,79);
    -webkit-box-shadow: 0 2px 12px -4px rgb(50,52,79);
  }
  .form p, .form h2{
    color:#fff !important;
    text-align: center;
  }
  .form p{
    margin-top: 20px;
    margin-bottom: 30px;
  }
  input[type="email"]{
    width:85%;
    padding:14px 20px;
    border-radius:8px 0 0 8px;
    margin:0;
    border: none;
  }
  #mailbox{
    position: absolute;
    right:-10px;
    bottom:35px;
    transition: bottom 0.15s ease-in;
    -webkit-transition: bottom 0.15s ease-in;
  }
  #subscribe:hover #mailbox{
    bottom:40px;
  }
  #subscribe:hover .btnPrimary, .btnPrimary:hover{
    background-color: #D2560E !important;
  }
  form{
    position: relative;
  }
  button[type="submit"]{
    cursor: pointer;
    position: absolute;
    right:0;
    top:0;
    -webkit-appearance: none;
    -moz-appearance: none;
    border: none;
    padding:12px;
    width:15%;
    background-color: #FA6400;
    border-radius: 0 8px 8px 0;
    transition: background-color 0.25s ease-in;
    -webkit-transition: background-color 0.25s ease-in;
  }
  button[type="submit"]:hover{
    background-color: #D2560E !important;
  }
  i{
    font-size: 24px;
    color:#fff;
  }
  .fade-enter-active, .fade-leave-active {
  transition: opacity .25s;
}
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/General/Subscribe.vue